module.exports = __webpack_public_path__ + "static/media/recompensa.a31fc924.svg";